import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Nft, NftShoppingCartItem } from "../models/Nft";


interface NftShoppingCartState {
 
  nftItems: NftShoppingCartItem[];
  loading: boolean;
  open: boolean;
  checkoutFormVisible: boolean;
 
}

const initialState: NftShoppingCartState = {
  nftItems: [],
  loading: false,
  open: false,
  checkoutFormVisible: false,
  
};
const nftShoppingCartSlice = createSlice({
  name: "nftShoppingCart",
  initialState,
  reducers: {
    addNftBrand: (state: NftShoppingCartState, action: PayloadAction<Nft>) => {
  const existingItemIndex = state.nftItems.findIndex(
    item => item.id === action.payload.id
  );

  if (existingItemIndex >= 0) {
    // If item already exists, increment quantity
    state.nftItems[existingItemIndex].quantity += 1;
  } else {
    // If item doesn't exist, add it with quantity 1
    state.nftItems.push({
      ...action.payload,
      quantity: 1,
      amount: 10 // Use provided amount or default to 10
    });
  }
},
    removeNftBrand: (state:NftShoppingCartState , action: PayloadAction<string>) => {
      state.nftItems = state.nftItems.filter(a=>a.id !== action.payload);
    },
    setNftBrands: (state:NftShoppingCartState , action: PayloadAction<NftShoppingCartItem[]>) => {
      state.nftItems = action.payload;
    },
    clearNftBrands: (state:NftShoppingCartState ) => {
      state.nftItems = [];
    },
    openShoppingCart: (state:NftShoppingCartState ) => {
      state.open = true;
    },
    closeShoppingCart: (state:NftShoppingCartState ) => {
      state.open = false;
    },
    openCheckoutForm: (state:NftShoppingCartState ) => {
      state.checkoutFormVisible = true;
    },
    
    closeCheckoutForm: (state:NftShoppingCartState ) => {
      state.checkoutFormVisible = false;
    },
    updateAmount: (state, action: PayloadAction<{ id: string; amount: number }>) => {
      const { id, amount } = action.payload;
      const itemIndex = state.nftItems.findIndex(item => item.id === id);
      if (itemIndex !== -1) {
        state.nftItems[itemIndex].amount = amount;
      }
    },
    updateQuantity: (state, action: PayloadAction<{ id: string; quantity: number }>) => {
  const { id, quantity } = action.payload;
  const itemIndex = state.nftItems.findIndex(item => item.id === id);
  if (itemIndex !== -1) {
    state.nftItems[itemIndex].quantity = quantity;
  }
},
  },
});
export const { setNftBrands, clearNftBrands, addNftBrand, removeNftBrand, openShoppingCart, closeShoppingCart, openCheckoutForm, closeCheckoutForm, updateQuantity, updateAmount,
 
} = nftShoppingCartSlice.actions;
export default nftShoppingCartSlice.reducer;